import { configureStore } from "@reduxjs/toolkit";
import userContextSlice from "./UserContext";

const store = configureStore({
    reducer:{
        userContext: userContextSlice.reducer
    }
});

export default store;